import { useEffect } from 'react';
export default function useAutoFocus(autoFocus, ref) {
  useEffect(() => {
    if (autoFocus && ref.current) ref.current.focus(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}